import { createGlobalStyle } from 'styled-components';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-toastify/dist/ReactToastify.css';
import './windowInfo.css';
import 'react-datepicker/dist/react-datepicker.css';

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
  }

  *:focus {
    outline: 0;
  }

  html,
  body,
  #root {
    height: 100%;
    text-rendering: optimizelegibility;
  }

  html {
    font-size: 62.5%;
  }

  body {
    -webkit-font-smoothig: antialiased;
    font-size: 1.6rem;
    background-color: #f2f2f2;
  }

  body,
  input,
  button {
    font: 14px 'Poppins', sans-serif;
  }

  a {
    text-decoration: none;
  }

  ul {
    list-style: none;
  }

  button {
    cursor: pointer;
  }

  .MuiFormHelperText-root {
    margin: -0.8rem 0 1rem .5rem;
  }

  .MuiSelect-select {
    padding-top: 10.5px;
    padding-bottom: 10.5px
  }

  .field-select > label[data-shrink='false'] {
    margin-left: 1rem !important;
    margin-top: -1rem !important;
  }

  .field-select > label[data-shrink='true'] {
    margin-top: -.6rem !important;
    margin-left: .9rem !important;
    background: #fff;
    z-index: 1;
    padding: 0 .8rem;
  }

  .MuiFormHelperText-root.Mui-error {
    margin-top: -1rem;
    margin-bottom: 1rem;
  }

  @media print {
    @page {
      size: portrait;
      margin: 5mm;
    }

    body {
      margin: 0 !important;
      padding: 0 !important;
    }

    /* Hide everything except the modal content */
    body > *:not(.MuiDialog-root) {
      display: none !important;
    }

    .MuiDialog-root {
      position: static !important;
      display: block !important;
      visibility: visible !important;
    }

    .MuiDialog-paper {
      position: static !important;
      left: auto !important;
      top: auto !important;
      width: auto !important;
      max-width: none !important;
      min-width: 0 !important;
      height: auto !important;
      overflow: visible !important;
      box-shadow: none !important;
      margin: 0 !important;
      padding: 0 !important;
      border: none !important;
      page-break-after: avoid !important;
      page-break-before: avoid !important;
    }

    .MuiDialogActions {
      display: none !important;
    }

    /* Hide print button during printing */
    .print-button {
      display: none !important;
    }

    /* Hide cancel button during printing */
    .hide-on-print {
      display: none !important;
    }

    .print-area {
      display: block !important;
      visibility: visible !important;
    }
  }
`;
